export default __webpack_public_path__ + "static/media/G0070.Death_of_a_Child_algo_GS_april22.1666194000000.b8f88619.jpg";